import type { I18nFn } from '#/i18n/types/I18nFn';

export enum JobFunction {
  ACCOUNTING_FINANCE = 'ACCOUNTING_FINANCE',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  ADVOCACY = 'ADVOCACY',
  ARTS_PHOTOGRAPHY = 'ARTS_PHOTOGRAPHY',
  BUSINESS_DEVELOPMENT = 'BUSINESS_DEVELOPMENT',
  CASE_SOCIAL_WORK = 'CASE_SOCIAL_WORK',
  CITIZENSHIP = 'CITIZENSHIP',
  COMMUNICATIONS = 'COMMUNICATIONS',
  COMMUNITY_BELONGING = 'COMMUNITY_BELONGING',
  COMMUNITY_ENGAGEMENT_OUTREACH = 'COMMUNITY_ENGAGEMENT_OUTREACH',
  COMMUNITY_ORGANIZING = 'COMMUNITY_ORGANIZING',
  CONSERVATION = 'CONSERVATION',
  CORPORATE_PHILANTHROPY = 'CORPORATE_PHILANTHROPY',
  CORPORATE_RESPONSIBILITY = 'CORPORATE_RESPONSIBILITY',
  COUNSELING = 'COUNSELING',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  DATABASE_ADMINISTRATION = 'DATABASE_ADMINISTRATION',
  DATA_EVALUATION_ANALYSIS = 'DATA_EVALUATION_ANALYSIS',
  DEVELOPMENT_FUNDRAISING = 'DEVELOPMENT_FUNDRAISING',
  DIRECT_SERVICES = 'DIRECT_SERVICES',
  DIVERSITY_EQUITY_INCLUSION = 'DIVERSITY_EQUITY_INCLUSION',
  EMPLOYEE_ENGAGEMENT = 'EMPLOYEE_ENGAGEMENT',
  EQUIPMENT_FACILITIES = 'EQUIPMENT_FACILITIES',
  EVENTS = 'EVENTS',
  PUBLIC_RELATIONS = 'PUBLIC_RELATIONS',
  GRANTS_ADMINISTRATION = 'GRANTS_ADMINISTRATION',
  GRAPHIC_DESIGN = 'GRAPHIC_DESIGN',
  HEALTHCARE_PROVIDER_PRACTITIONER = 'HEALTHCARE_PROVIDER_PRACTITIONER',
  HUMAN_RESOURCES = 'HUMAN_RESOURCES',
  INVESTIGATIONS = 'INVESTIGATIONS',
  LEGAL = 'LEGAL',
  MARKETING = 'MARKETING',
  OPERATIONS = 'OPERATIONS',
  PARTNERSHIPS = 'PARTNERSHIPS',
  PROGRAM_MANAGEMENT = 'PROGRAM_MANAGEMENT',
  RESEARCH = 'RESEARCH',
  SAFETY_RESOURCE_PROTECTION = 'SAFETY_RESOURCE_PROTECTION',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  STRATEGY_PLANNING = 'STRATEGY_PLANNING',
  SUPPLIES_PROCUREMENT_DISTRIBUTION = 'SUPPLIES_PROCUREMENT_DISTRIBUTION',
  SUSTAINABILITY = 'SUSTAINABILITY',
  TEACHING_INSTRUCTION = 'TEACHING_INSTRUCTION',
  TECHNOLOGY_IT = 'TECHNOLOGY_IT',
  WRITING_EDITORIAL = 'WRITING_EDITORIAL',
}

export function JOB_FUNCTIONS(i18n: I18nFn) {
  return {
    [JobFunction.ACCOUNTING_FINANCE]: i18n('Accounting & Finance'),
    [JobFunction.ADMINISTRATIVE]: i18n('Administrative'),
    [JobFunction.ADVOCACY]: i18n('Advocacy'),
    [JobFunction.ARTS_PHOTOGRAPHY]: i18n('Arts & Photography'),
    [JobFunction.BUSINESS_DEVELOPMENT]: i18n('Business Development'),
    [JobFunction.CASE_SOCIAL_WORK]: i18n('Case/Social Work'),
    [JobFunction.CITIZENSHIP]: i18n('Citizenship'),
    [JobFunction.COMMUNICATIONS]: i18n('Communications'),
    [JobFunction.COMMUNITY_BELONGING]: i18n('Community Belonging'),
    [JobFunction.COMMUNITY_ENGAGEMENT_OUTREACH]: i18n(
      'Community Engagement/Outreach',
    ),
    [JobFunction.COMMUNITY_ORGANIZING]: i18n('Community Organizing'),
    [JobFunction.CONSERVATION]: i18n('Conservation'),
    [JobFunction.CORPORATE_PHILANTHROPY]: i18n('Corporate Philanthropy'),
    [JobFunction.CORPORATE_RESPONSIBILITY]: i18n('Corporate Responsibility'),
    [JobFunction.COUNSELING]: i18n('Counseling'),
    [JobFunction.CUSTOMER_SERVICE]: i18n('Customer Service'),
    [JobFunction.DATABASE_ADMINISTRATION]: i18n('Database Administration'),
    [JobFunction.DATA_EVALUATION_ANALYSIS]: i18n('Data Evaluation/Analysis'),
    [JobFunction.DEVELOPMENT_FUNDRAISING]: i18n('Development/Fundraising'),
    [JobFunction.DIRECT_SERVICES]: i18n('Direct Services'),
    [JobFunction.DIVERSITY_EQUITY_INCLUSION]: i18n(
      'Diversity, Equity & Inclusion',
    ),
    [JobFunction.EMPLOYEE_ENGAGEMENT]: i18n('Employee Engagement'),
    [JobFunction.EQUIPMENT_FACILITIES]: i18n('Equipment & Facilities'),
    [JobFunction.EVENTS]: i18n('Events'),
    [JobFunction.GRANTS_ADMINISTRATION]: i18n('Grants Administration'),
    [JobFunction.GRAPHIC_DESIGN]: i18n('Graphic Design'),
    [JobFunction.HEALTHCARE_PROVIDER_PRACTITIONER]: i18n(
      'Healthcare Provider/Practitioner',
    ),
    [JobFunction.HUMAN_RESOURCES]: i18n('Human Resources'),
    [JobFunction.INVESTIGATIONS]: i18n('Investigations'),
    [JobFunction.LEGAL]: i18n('Legal'),
    [JobFunction.MARKETING]: i18n('Marketing'),
    [JobFunction.OPERATIONS]: i18n('Operations'),
    [JobFunction.PARTNERSHIPS]: i18n('Partnerships'),
    [JobFunction.PROGRAM_MANAGEMENT]: i18n('Program Management'),
    [JobFunction.PUBLIC_RELATIONS]: i18n('Public Relations'),
    [JobFunction.RESEARCH]: i18n('Research'),
    [JobFunction.SAFETY_RESOURCE_PROTECTION]: i18n(
      'Safety & Resource Protection',
    ),
    [JobFunction.SOCIAL_MEDIA]: i18n('Social Media'),
    [JobFunction.STRATEGY_PLANNING]: i18n('Strategy & Planning'),
    [JobFunction.SUPPLIES_PROCUREMENT_DISTRIBUTION]: i18n(
      'Supplies Procurement/Distribution',
    ),
    [JobFunction.SUSTAINABILITY]: i18n('Sustainability'),
    [JobFunction.TEACHING_INSTRUCTION]: i18n('Teaching & Instruction'),
    [JobFunction.TECHNOLOGY_IT]: i18n('Technology/IT'),
    [JobFunction.WRITING_EDITORIAL]: i18n('Writing/Editorial'),
  } satisfies Record<JobFunction, string>;
}

export function JOB_FUNCTIONS_RADIO_OR_SELECT_OPTIONS(i18n: I18nFn) {
  return (Object.entries(JOB_FUNCTIONS(i18n)) as Array<[JobFunction, string]>)
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      value: key,
      label: value,
    }));
}

export function JOB_FUNCTIONS_CHECKBOX_OPTIONS(i18n: I18nFn) {
  return Object.entries(JOB_FUNCTIONS(i18n))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      name: key,
      label: value,
    }));
}
